import type { SolutionSector } from "../sectors";
import { ASK_LINE, LOGO } from "./shared";

export const FINTECH: SolutionSector = {
  slug: "fintech",
  name: "Fintech",
  demoOrg: "Demo (FinTech)",
  story: "fintech",
  metadata: {
    title: "AI for fintech implementation reviews | Your Twin",
    description:
      "Know what is blocking each customer start. Your Twin connects HubSpot, Linear, Google Drive and Slack, so you can see open dependencies, missing evidence and owners before the next call.",
  },
  hero: {
    label: "Fintech",
    title: ["Know what’s", "blocking the", "customer start."],
    lead: [
      "Spend less time chasing implementation updates. Your Twin connects customer records in ",
      LOGO.hubspot,
      " with tasks in ",
      LOGO.linear,
      ", checklists in ",
      LOGO.drive,
      " and conversations in ",
      LOGO.slack,
      ", so you can see which starts have open dependencies and who owns the follow-up.",
    ],
    cta: "Bring a customer implementation",
    buyer: "For COOs, heads of operations and customer operations directors",
    instrumentLabel: "The fintech Twin · Customer, start, dependency and owner",
    legendLines: [
      "Read HubSpot, Linear, Google Drive and Slack.",
      "Link each customer to its implementation tasks, checklists and conversations.",
      "Build one picture of each customer start.",
      "Check the connections and dates against your source records.",
      "Have agents prepare implementation reviews and flag open dependencies.",
      "Save their work in shared channels: start trackers and review tables.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "Which starts are blocked?\nAnd by what?",
    lead: "Ask across HubSpot, Linear, Google Drive and Slack. See each open dependency beside the customer’s start date and its recorded owner.",
  },
  outcomes: {
    title: "Every start, with\nits blockers in view.",
    lead: "Operations sees each customer start beside its open dependencies, its evidence and its owner.",
    items: [
      { title: "Find the blocked start.", body: "Bring open dependencies beside the customer’s target date.", show: "status" },
      { title: "Locate the missing evidence.", body: "See what the connected checklist still needs.", show: "sources" },
      { title: "Make the handover clear.", body: "Keep the recorded owner and follow-up beside the work.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose an implementation review your team prepares today." },
  questions: [
    { q: "Does this perform KYC or AML checks?", a: "No. This workflow prepares an implementation review. It doesn’t establish customer clearance or replace your compliance team." },
    {
      q: "Will it change customer or payment records?",
      a: "Connections start read-only. The Twin can suggest a next step; your team decides what happens, and this workflow changes nothing.",
    },
    {
      q: "Can we use it with regulated information?",
      a: "We agree the records, access, hosting and model processing with your team before connecting anything. A dedicated server doesn’t settle those requirements on its own.",
    },
  ],
  closing: "Start with one customer implementation\nyour team keeps chasing.",
};
